import { NotFoundPage } from "@climatepartner/components/ErrorPages";
import { Spinner } from "@climatepartner/components/Spinner";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import { useFeatureToggles } from "../../shared/feature-flags/use-feature-toggles";
import { lazyWithChunkReload } from "../../shared/lib/chunk-load-recovery";
import { ECONAUT_AT_A_GLANCE_PATH, ECONAUT_DEMO_PATH } from "../../shared/routing/paths/app";

const EconautDemo = lazyWithChunkReload(() =>
  import("./econaut-demo.main").then((m) => ({ default: m.EconautDemoMain }))
);

const EconautAtAGlance = lazyWithChunkReload(() =>
  import("./at-a-glance/econaut-at-a-glance-page").then((m) => ({ default: m.EconautAtAGlancePage }))
);

/**
 * When the `econautDemo` ConfigCat flag is off every econaut-demo route renders `NotFoundPage`
 * (404), keeping the feature hidden.
 */
const EconautDemoGuard = () => {
  const { enabled } = useFeatureToggles("econautDemo");

  if (!enabled) {
    return <NotFoundPage />;
  }

  return (
    <Suspense fallback={<Spinner />}>
      <Outlet />
    </Suspense>
  );
};

export const EconautDemoRoutes = {
  path: ECONAUT_DEMO_PATH,
  element: <EconautDemoGuard />,
  children: [
    { index: true, element: <EconautDemo /> },
    { path: ECONAUT_AT_A_GLANCE_PATH, element: <EconautAtAGlance /> },
  ],
};
